import React from "react";
import * as Sentry from "@sentry/react";

function ErrorFallback({ error, componentStack }) {
  return (
    <div id="error-page">
      <div className="content">
        <h2 className="header" data-text="Oops :-)">
          Oops :-)
        </h2>
        <h4 data-text="Oops :-) Something went wrong">
          Something went wrong
        </h4>
        <p>
          The page encounter an issue while performing this action, Sorry for the inconvenience.
          {error && <details style={{ cursor: "pointer" }}>
            <summary>Read Error</summary>
            <div id="error-title">{error.message || "None"}</div>
            <div id="error-stack">
              <code>
                {componentStack || "No Description"}
              </code>
            </div>
          </details>}
        </p>
        <div className="btns">
          <a href="/">return home</a>
        </div>
      </div>
    </div>
  );
}

const ErrorBoundary = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
